<template>
    <div class="menu-detail">
        <div class="top-main">
            <div class="header-main">
                <a
                    class="btn-back"
                    id="menudetail-goback-btn"
                    @click="backHistory"
                >
                    <img
                        class="white-back"
                        src="@/assets/campaignlist/white_back.svg"
                        alt=""
                    />
                    <p>ย้อนกลับ</p>
                </a>
                <div class="top-button-container">
                    <div @click="purchaseItem" class="cart-container">
                        <img
                            v-if="isEmpty"
                            id="menu-gotocart-btn"
                            class="top-button"
                            src="@/assets/home/empty_cart.svg"
                        />
                        <img
                            v-else
                            id="menu-gotocart-btn"
                            class="top-button"
                            src="@/assets/home/cart_icon.svg"
                        />
                        <span v-if="!isEmpty" class="cart-amount">{{
                            cartCount
                        }}</span>
                    </div>
                </div>
            </div>
            <div class="image-main">
                <div class="image-container">
                    <img :src="campaignImage" alt="" />
                </div>
                <div class="price-container">
                    <div class="price-detail">{{ price }}</div>
                    <div class="price-unit">บาท</div>
                </div>
            </div>
        </div>
        <div class="detail-main">
            <div class="title-container">{{ title }}</div>
            <div class="desc-container">{{ campaignData.detail }}</div>
            <div v-if="isSweetness" class="sweet-container">
                <div class="sweet-title">ระดับความหวาน</div>
                <ul id="menudetail-sweetness-list" class="sweet-bar">
                    <li
                        v-for="(item, index) of sweetbar"
                        :key="index"
                        @click="chooseSweet(item)"
                    >
                        <p :class="{ active: item === activeSweet }">
                            {{ item }}
                        </p>
                    </li>
                </ul>
            </div>
            <div
                id="menudetail-addshot-list"
                v-if="isExtra"
                class="checkbox-container"
            >
                <checkbox-detail
                    :detail="checkboxDetail.extra"
                    @add="addShot"
                    @remove="removeShot"
                ></checkbox-detail>
            </div>
            <div class="detail-container">
                <div class="detail-header">รายละเอียดเพิ่มเติม</div>
                <textarea
                    id="menudetail-detail-textarea"
                    v-model="orderDetail"
                    class="detail-input"
                ></textarea>
            </div>
            <div class="amount-container">
                <div class="amount-unit">จำนวน</div>
                <div class="amount-controller">
                    <div
                        id="menudetail-minusamount-btn"
                        @click="changeAmount('minus')"
                        class="minus"
                    >
                        <img
                            v-if="amount > 1"
                            src="@/assets/campaignlist/minus_active.svg"
                            alt=""
                        />
                        <img
                            v-else
                            src="@/assets/campaignlist/minus_inactive.svg"
                            alt=""
                        />
                    </div>
                    <div id="menudetail-plusamount-btn" class="amount">
                        {{ amount }}
                    </div>
                    <div @click="changeAmount('plus')" class="plus">
                        <img
                            src="@/assets/campaignlist/plus_active.svg"
                            alt=""
                        />
                    </div>
                </div>
            </div>
        </div>
        <div class="btn-main">
            <div class="btn-price">
                <div class="price-header">ราคารวม</div>
                <div class="total-price">{{ totalPrice }}</div>
            </div>
            <div
                id="menudetail-addcart-btn"
                @click="addToChart()"
                class="btn-cart"
            >
                เพิ่มเข้าตะกร้า
            </div>
        </div>
        <b-modal
            id="locationAlert"
            centered
            hide-header
            hide-footer
            no-close-on-backdrop
            no-close-on-esc
        >
            <div class="success-main">
                <div
                    id="menudetail-successmodule-close-btn"
                    class="close-btn"
                    @click="$bvModal.hide('locationAlert')"
                >
                    <img src="@/assets/profile/close-new.svg" alt="" />
                </div>
                <div class="success-header">
                    <div class="title-scc">
                        <h2>กรุณาเลือกสาขา</h2>
                        <p>กรุณาเลือกสาขา Nescafe Street Cafe ใกล้คุณ</p>
                    </div>
                </div>
                <div
                    id="menudetail-successmodule-confirm-btn"
                    class="success-btn"
                    @click="$router.push('/cafemap/menu')"
                >
                    ตกลง
                </div>
            </div>
        </b-modal>
        <ModalMaster :controller="modalController"></ModalMaster>
        <div class="alert-cart" v-show="showAlert" @click="addToChart()">
            <img src="@/assets/campaignlist/cart_nobg.svg" alt="" />
            เพิ่มลงตะกร้า
        </div>
    </div>
</template>

<script>
//components
import checkboxDetail from "@/module/Menu/component/CheckboxDetail.vue";
//mixin
import Mixin from "@/mixin/Mixin";
import ModalMixin from "@/mixin/ModalMixin.js";
//core
import BzbsCart from "@/core/Cart/service/BzbsCart.js";
import BzbsCampaign from "@/core/Campaign/service/BzbsCampaign.js";
import { CampaignListConfigBuilder } from "@/core/Campaign/model/CampaignConfigModel.js";
import { CampaignConfigBuilder } from "@/core/Campaign/model/CampaignConfigModel.js";
import { DetailController } from "@/module/Detail/controller/DetailController.js";
import ConfigManager from "@/config/ConfigManager.js";
// helper
import CacheHelper from "@/helper/CacheHelper.js";
import Account from "@/helper/AccountHelper.js";
import Locale from "@/helper/locale/locale.js";
//vuex
import { mapGetters } from "vuex";

export default {
    name: "MenuDetail",
    mixins: [Mixin, ModalMixin],
    components: {
        checkboxDetail,
    },
    props: {
        campaignImage: String,
        campaign: Object,
    },
    data: function () {
        return {
            cacheHelper: new CacheHelper(),
            userToken: null,
            price: 0,
            title: "",
            desc: "",

            amount: 1,
            totalPrice: 0,

            checkboxDetail: {
                extra: {
                    title: "เพิ่มเติม",
                    list: [],
                },
            },
            //merge sweetbar and sweetnessCode when campaign is set
            sweetbar: ["0%", "25%", "50%", "75%", "100%"],
            sweetnessCode: [],
            activeSweet: "100%",
            showAlert: false,

            campaignId: null,
            campaignConfig: null,

            extraContent: {},

            isExtra: false,
            isSweetness: false,

            toppingList: [],
            shotList: [],
            toppingPrice: 0,
            shotPrice: 0,

            campaignListConfig: {},
            campaignData: {},
            orderDetail: "",

            cartCount: 0,

            detailController: new DetailController(),
            isEmpty: true,
        };
    },
    created() {
        this.userToken = this.cacheHelper.getCache("BzbsUser").token;
        this.initialConfig();
        this.getCampaign();
        this.getCartQty();
    },
    computed: mapGetters(["getLocationStore"]),
    methods: {
        initialConfig: function () {
            this.price = this.campaign.originalPrice;
            this.totalPrice = this.campaign.originalPrice;
            this.title = this.campaign.name;
            this.campaignId = this.campaign.id;
            this.desc = this.campaign.detail;
            this.campaignConfig = new CampaignConfigBuilder()
                .setCampaignId(this.campaignId)
                .create();

            this.setupDetailController();
        },
        setupDetailController: function () {
            this.handleLoading(true);
            this.detailController
                .initial(this.campaignConfig)
                .then((campaign) => {
                    this.campaignData = campaign;
                    console.log("campaign : ", campaign);
                })
                .catch((err) => {
                    this.errorResponse(err);
                })
                .finally(() => {
                    this.handleLoading(false);
                });
        },
        getCampaign: function () {
            this.extraContent = JSON.parse(
                this.campaign.extra
            ).addons_config_list;

            console.log(this.extraContent);
            let strBzbsToken = Account.getToken();

            for (let i = 0; i < this.extraContent.length; i++) {
                this.campaignListConfig = {};
                var listConfig = new CampaignListConfigBuilder()
                    .setConfigList(this.extraContent[i].config)
                    .setTop(25);

                this.campaignListConfig = listConfig.create();

                if (
                    this.extraContent[i].config !==
                    "campaign_nescafestreet_auto_addon_sweetness"
                ) {
                    BzbsCampaign.apiGetCampaign(
                        strBzbsToken,
                        this.campaignListConfig,
                        null
                    ).subscribe(
                        (campaigns) => {
                            let shotArray = [];
                            for (let i = 0; i < campaigns.length; i++) {
                                // check topping shot
                                // เรียงเอา ช็อตขึ้นก่อน
                                if (
                                    campaigns[i].name.endsWith("ช็อต") ||
                                    campaigns[i].name.endsWith("(ช็อต)")
                                ) {
                                    shotArray.unshift({
                                        id: campaigns[i].id,
                                        name: campaigns[i].name,
                                        price: campaigns[i].pricePerUnit,
                                    });
                                } else {
                                    this.checkboxDetail.extra.list.push({
                                        id: campaigns[i].id,
                                        name: campaigns[i].name,
                                        price: campaigns[i].pricePerUnit,
                                    });
                                }
                            }
                            shotArray.reverse().forEach((item) => {
                                this.checkboxDetail.extra.list.unshift(item);
                            });
                        },
                        (err) => {
                            console.log(err);
                        }
                    );
                } else {
                    BzbsCampaign.apiGetCampaign(
                        strBzbsToken,
                        this.campaignListConfig,
                        null
                    ).subscribe(
                        (campaigns) => {
                            // console.log(campaigns);
                            for (let item of this.sweetbar) {
                                let result = campaigns.find(
                                    (element) => element["name"] === item
                                );
                                if (result) {
                                    this.sweetnessCode.push(result);
                                }
                            }
                        },
                        (err) => {
                            console.log(err);
                        }
                    );
                }

                switch (this.extraContent[i].section) {
                    case "sweetness":
                        this.isSweetness = true;
                        break;
                    case "extra":
                        this.isExtra = true;
                        break;
                }
            }
            this.isLoaded = true;
        },
        backHistory() {
            this.$router.push("/menu");
        },
        chooseSweet(value) {
            this.activeSweet = value;
        },
        addToChart() {
            let result = this.sweetnessCode.find(
                (element) => element["name"] === this.activeSweet
            );
            let jsonForm = [];

            jsonForm.push(result["id"]);

            for (let item of this.shotList) {
                console.log(item);
                jsonForm.push(item["id"]);
            }
            BzbsCart.apiAddToCart(
                this.userToken,
                jsonForm,
                this.campaignId,
                this.amount,
                this.orderDetail
            ).subscribe(
                (res) => {
                    console.log(res);
                    this.showAlert = true;
                    setTimeout(() => {
                        this.showAlert = false;
                        this.getCartQty();
                        this.$nextTick(() => {
                            this.$router.push("/menu");
                        });
                    }, 2000);
                },
                (err) => {
                    console.log(err);
                    this.alertModal
                        .setTitle("เกิดข้อผิดพลาด")
                        .setMsg(err.message)
                        .show();
                }
            );
        },
        errorHandler: function (errorObj) {
            alert(
                errorObj.code +
                    ": " +
                    errorObj.message +
                    " use default location"
            );
        },
        purchaseItem() {
            if (this.getLocationStore.location) {
                let locale = Locale.getLocaleCode();
                let urlLocation = window.location.origin;
                let urlBack = urlLocation + "/menu";
                let urlOrder = urlLocation + "/order";
                window.location.replace(
                    ConfigManager.getApiShoppingUrl() +
                        "/nescafestreetcafe?theme=nescafestreetcafe" +
                        "&token=" +
                        this.userToken +
                        "&locale=" +
                        locale +
                        "&return_url=" +
                        urlBack +
                        "&myorder_url=" +
                        urlOrder +
                        "&lat=" +
                        this.getLocationStore.lat +
                        "&lng=" +
                        this.getLocationStore.lng +
                        "&locationId=" +
                        "" +
                        "&api=stgnsc2"
                );
            } else {
                this.$bvModal.show("locationAlert");
            }
        },
        getCartQty() {
            BzbsCart.apiGetCartCount(this.userToken).subscribe(
                (res) => {
                    this.cartCount = res.cart_count;
                    if (this.cartCount !== 0) {
                        this.isEmpty = false;
                    }
                },
                (err) => {
                    console.log(err);
                }
            );
        },
        changeAmount(operation) {
            if (operation === "plus") {
                this.amount++;
            } else if (operation === "minus" && this.amount > 1) {
                this.amount--;
            }
            this.totalPrice =
                this.amount * (this.price + this.toppingPrice + this.shotPrice);
        },
        // topping flow
        // addTopping(value){
        //     //change topping list
        //     this.toppingList.push(value)
        //     //calculate topping price
        //     this.toppingPrice = 0;
        //     for(let i = 0; i < this.toppingList.length; i++) {
        //         this.toppingPrice = this.toppingPrice + this.toppingList[i].price
        //     }

        //     this.calculatePrice()
        // },
        // removeTopping(value){
        //     //change topping list
        //     this.toppingList = this.toppingList.filter(item => {
        //         return item.name !== value.name
        //     })
        //     //calculate topping price
        //     this.toppingPrice = 0;
        //     for(let i = 0; i < this.toppingList.length; i++) {
        //         this.toppingPrice = this.toppingPrice + this.toppingList[i].price
        //     }

        //     this.calculatePrice()
        // },
        addShot(value) {
            //change shotList
            this.shotList.push(value);
            console.log(this.shotList);
            //calculate shot price
            this.shotPrice = 0;
            this.shotPrice = value.price * this.shotList.length;

            this.calculatePrice();
        },
        removeShot(value) {
            //all shot have the same name and value
            //change shot list
            this.shotList.pop();
            //calculate shot price
            this.shotPrice = 0;
            this.shotPrice = value.price * this.shotList.length;

            this.calculatePrice();
        },
        calculatePrice() {
            this.totalPrice =
                this.amount * (this.price + this.toppingPrice + this.shotPrice);
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@/module/Menu/style/mission.scss";
$light-brown: #a7907b;
$dark-brown: #4d341c;

textarea {
    background-color: rgba($color: #fff, $alpha: 0.2);
}
.menu-detail {
    color: #fff;
    background: url("../../../assets/home/BG@3x.png");
    .top-main {
        background: url("../../../assets/campaignlist/menu_bg.svg") center
            center no-repeat;
        background-size: cover;
        height: 33vh;
        .header-main {
            .btn-back {
                display: flex;
                position: absolute;
                left: 20px;
                top: 35px;
                z-index: 5;
                img {
                    height: 24px;
                }
                p {
                    font-size: 12px;
                    margin: 0;
                    text-decoration: none;
                    color: #fff;
                    display: flex;
                    align-items: center;
                }
            }
            .btn-container {
                position: absolute;
                right: 20px;
                top: 20px;
                .top-button {
                    margin-left: 10px;
                    img {
                        height: 2px;
                    }
                }
            }
        }
        .image-main {
            .price-container {
                background-color: $light-brown;
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                position: absolute;
                flex-direction: column;
                bottom: 62vh;
                right: 20px;
                height: 5.25rem;
                width: 5.25rem;
                z-index: 1;
            }
            img {
                position: absolute;
                bottom: 56vh;
                left: -35px;
                width: 80vw;
            }
        }
    }
    .detail-main {
        background-color: #000;
        .title-container {
            padding-top: 60px;
            margin: 0 15px 10px;
            font-size: 18px;
            font-family: "PromptSemiBold";
        }
        .desc-container {
            margin: 0 15px 15px;
            font-size: 14px;
        }
        .sweet-container {
            margin: 0 15px 10px;
            background-color: rgba($color: #fff, $alpha: 0.2);
            border-radius: 15px;
            padding: 10px 15px;

            .sweet-title {
                font-size: 16px;
                margin-bottom: 10px;
            }
            .sweet-bar {
                background-color: rgba($color: #fff, $alpha: 0.3);
                font-size: 14px;
                border-radius: 10px;
                display: flex;
                list-style: none;
                color: #fff;
                justify-content: space-between;
                padding: 0px;
                margin: 0;
                height: 2rem;

                p {
                    margin: 0;
                    padding: 0 16px;
                    height: 2rem;
                    display: flex;
                    text-align: center;
                    align-items: center;
                    &.active {
                        background-color: $light-brown;
                        border-radius: 10px;
                    }
                }
            }
        }
        .checkbox-container {
            margin: 0 15px 10px;
        }
        .detail-container {
            background-color: rgba($color: #fff, $alpha: 0.2);
            border-radius: 15px;
            margin: 0 15px 10px;
            padding: 10px 15px;
            .detail-header {
                font-size: 16px;
                margin-bottom: 10px;
            }
            .detail-input {
                border: $light-brown 2px solid;
                border-radius: 10px;
                resize: none;
                width: 100%;
            }
        }
        .amount-container {
            display: flex;
            background-color: rgba($color: #fff, $alpha: 0.2);
            border-radius: 15px;
            margin: 0 15px;
            padding: 10px 15px;
            justify-content: space-between;
            align-items: center;
            .amount-controller {
                display: flex;
                font-size: 16px;
                img {
                    margin-left: 15px;
                    height: 30px;
                }
                .amount {
                    margin-left: 15px;
                    display: flex;
                    align-items: center;
                }
            }
        }
    }
    .btn-main {
        display: flex;
        padding: 15px 20px;
        background-color: #000;
        justify-content: space-between;
        .btn-price {
            .price-header {
                font-size: 14px;
            }
            .total-price {
                font-size: 18px;
                font-family: "PromptSemiBold";
            }
        }
        .btn-cart {
            border-radius: 40px;
            padding: 10px 50px;
            background-color: $dark-brown;
            font-size: 16px;
            font-family: "PromptSemiBold";
        }
    }
}
.modal-content {
    .success-main {
        .close-btn {
            float: right;
        }
        .success-header {
            .title-scc {
                h2 {
                    color: $light-brown;
                    text-align: center;
                    font-size: 18px;
                    margin-bottom: 1.5rem;
                    font-family: "PromptSemiBold";
                }
                p {
                    color: #000;
                    text-align: center;
                    font-size: 16px;
                    margin-bottom: 1.5rem;
                    padding: 0 50px;
                }
            }
        }
        .success-btn {
            text-align: center;
            color: #fff;
            background: $dark-brown;
            padding: 0;
            border-radius: 40px;
            font-size: 1rem;
            height: 45px;
            line-height: 45px;
        }
    }
}
.alert-cart {
    position: fixed;
    top: 35vh;
    left: 28vw;
    width: 44%;
    height: 13%;
    background-color: #a7907b;
    opacity: 0.9;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 15px;
    img {
        margin-bottom: 15px;
    }
}
</style>
